<template>
  <MenuItems>
    <MenuItem
      v-for="({ item, depth }, i) in oneDimensionalItems"
      :key="i"
      as="div"
      :style="{ paddingLeft: `${depth * 1.5}rem` }"
    >
      <FilterMenuHeading v-if="item.heading" :title="item.title" :small="small">
        <slot :item="item" :index="i" :depth="depth" />
      </FilterMenuHeading>
      <FilterMenuCheckboxItem
        v-else
        v-model="model"
        :item="item"
        :small="small"
        :bold="Boolean(item.children)"
      >
        <template #default>
          <slot :item="item" :index="i" :depth="depth" />
        </template>
        <template #count>
          <slot name="count" :item="item" :index="i" :depth="depth" />
        </template>
      </FilterMenuCheckboxItem>
    </MenuItem>
  </MenuItems>
</template>

<script lang="ts" setup generic="T">
import type { AnyFilterItem, FilterMenuValue } from "./FilterMenuTypes";
import { traverseItems } from "./traverseItems";

interface Props {
  items: AnyFilterItem<T>[];
  modelValue: FilterMenuValue<T>[];
  small?: boolean;
}

type Emits = {
  "update:modelValue": [items: Props["modelValue"]];
};

const { small = false, items } = defineProps<Props>();
defineEmits<Emits>();

const model = defineModel<Props["modelValue"]>({
  required: true,
});

const oneDimensionalItems = computed(() => {
  const tmpItems: {
    item: AnyFilterItem<T>;
    depth: number;
  }[] = [];
  traverseItems(
    items,
    ({ item, depth }) => {
      tmpItems.push({
        item,
        depth,
      });
    },
    { skipDepthIncrease: (item) => Boolean(item.heading) }
  );
  return tmpItems;
});
</script>
